import { Link, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../../api/admin';
import { AdminLayout } from '../../components/AdminLayout';
import { AuditDashboardContent } from '../../components/AuditDashboardContent';

export function AdminCustomerAuditPage() {
  const { id } = useParams<{ id: string }>();
  const customerQuery = useQuery({
    queryKey: ['admin', 'customers', id],
    queryFn: () => adminApi.getCustomer(id!),
    enabled: !!id,
  });

  if (!id) return null;

  if (customerQuery.isLoading) {
    return (
      <AdminLayout>
        <p className="text-sm text-wc-muted">Loading…</p>
      </AdminLayout>
    );
  }
  if (customerQuery.isError || !customerQuery.data) {
    return (
      <AdminLayout>
        <p className="text-sm text-wc-red">Failed to load customer.</p>
      </AdminLayout>
    );
  }

  const customer = customerQuery.data;

  return (
    <AdminLayout>
      <div className="mb-4 flex items-center gap-3">
        <Link
          to={`/admin/customers/${customer.id}`}
          className="text-xs uppercase tracking-wider text-wc-muted-strong hover:text-wc-blue"
        >
          ← Back to customer
        </Link>
      </div>
      <AuditDashboardContent
        scopeKey={`admin:${customer.id}`}
        scopeLabel={customer.displayName}
        activeCustomerSlug={customer.slug}
        getSummary={(from, to) => adminApi.auditSummary(customer.id, from, to)}
        getEvents={(filters) => adminApi.auditEvents(customer.id, filters)}
        getEngagements={(filters) => adminApi.auditEngagements(customer.id, filters)}
      />
    </AdminLayout>
  );
}
